<template>
    <adminTable />
</template>

<script setup></script>

<style lang="less" scoped>
    
</style>